import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { Checkbox } from '~/components/Form';
import { T } from '~/components/I18n';
import { useLevelUpRequirement } from '~/components/Level/Level.hooks';
import { LevelUpValues } from '~/components/LevelUp/LevelUp';
import { InlineList } from '~/components/List/Inline/InlineList';
import styles from './LevelUpRequirementList.module.scss';

export type LevelUpRequirementListProps = {
  className?: string;
};

export const LevelUpRequirementList = ({ className }: LevelUpRequirementListProps) => {
  const { values, errors } = useFormikContext<LevelUpValues>();
  const { level } = values;
  const {
    data: {
      purchase: { minAmount: requiredPurchase },
    },
  } = useLevelUpRequirement(level);

  return (
    <InlineList className={classNames(styles.list, className)} divided>
      <li>
        <Checkbox
          className={styles.checkbox}
          variant="circle"
          checked={!errors.tokenIdList}
          readOnly
        />
        <T name="citizen_membership_levelup_floating_desc1" />
      </li>
      <li>
        <Checkbox className={styles.checkbox} variant="circle" checked={!errors.balance} readOnly />
        <span>DON</span>
      </li>
      {requiredPurchase > 0 && (
        <li>
          <Checkbox
            className={styles.checkbox}
            variant="circle"
            checked={!errors.purchase}
            readOnly
          />
          <T name="citizen_membership_guide_levelup_menu2" />
        </li>
      )}
    </InlineList>
  );
};
